import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import './search.css';
import '../style.css'
import {Link } from "react-router-dom";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={5}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


function SimpleTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div>
       <div class="flex-tabs">
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
          <Tab class="tab-btn active" label="All" {...a11yProps(0)} />
          <Tab class="tab-btn" label="Forward" {...a11yProps(1)} />
          <Tab class="tab-btn" label="Reverse" {...a11yProps(2)} />
          <Tab class="tab-btn" label="Silent" {...a11yProps(3)} />
          <Tab class="tab-btn" label="Penny" {...a11yProps(4)} />
        </Tabs>
        </div>
        
       <TabPanel value={value} index={0}>
          <div class="flex-tabs-content d-flex justify-between flex-wrap">
              <div>
                   <img src="./images/product.PNG" alt="product"></img>
                   <h2>HOUSING</h2>
                   <a href='http://housing.auctionsoftware.com/' target='_blank'>View Demo</a>
               </div>                         
               <div>
                   <img src="./images/product1.PNG" alt="product"></img>
                   <h2>ANTIQUE</h2>
                   <Link to="/view1">View Demo</Link>
                 
               </div>                         
               <div>
                   <img src="./images/product2.PNG" alt="product"></img>
                   <h2>SPEEDBID</h2>
                   <Link to="/view2">View Demo</Link>
               </div>                         
               <div>
                   <img src="./images/product3.png" alt="product"></img>
                   <h2>CARBID</h2>
                   <Link to="/view3">View Demo</Link>
               </div>                         
               <div>
                   <img src="./images/product4.PNG" alt="product"></img>
                   <h2>PENNY AUCTION</h2>
                   <Link to="/view4">View Demo</Link>
               </div> 
               <div>
                   <img src="./images/product5.PNG" alt="product"></img>
                   <h2>REVERSE AUCTION</h2>
                   <Link to="/view5">View Demo</Link>
               </div>                         
               </div>
      </TabPanel>
      <TabPanel value={value} index={1}>
      <div class="flex-tabs-content d-flex justify-between flex-wrap">
              <div>
                   <img src="./images/product.PNG" alt="product"></img>
                   <h2>HOUSING</h2>
                   <a href='http://housing.auctionsoftware.com/' target='_blank'>View Demo</a>
               </div> 
               <div>
                   <img src="./images/product1.PNG" alt="product"></img>
                   <h2>ANTIQUE</h2>
                   <Link to="/view1">View Demo</Link>
               </div> 
               <div>
                   <img src="./images/product3.png" alt="product"></img>
                   <h2>CARBID</h2>
                   <Link to="/view3">View Demo</Link>
               </div>                         
            </div>
      </TabPanel>
      <TabPanel value={value} index={2}>
      <div class="flex-tabs-content d-flex justify-between flex-wrap">
              <div>
                   <img src="./images/product5.PNG" alt="product"></img>
                   <h2>REVERSE AUCTION</h2>
                   <Link to="/view5">View Demo</Link>
               </div>    
      </div>
      </TabPanel>
      <TabPanel value={value} index={3}>
      <div class="flex-tabs-content d-flex justify-between flex-wrap">
           <p>No Website found</p>
      </div>
      </TabPanel>
      <TabPanel value={value} index={4}>
      <div class="flex-tabs-content d-flex justify-between flex-wrap">
               <div>
                   <img src="./images/product4.PNG" alt="product"></img>
                   <h2>PENNY AUCTION</h2>
                   <Link to="/view4">View Demo</Link>
               </div> 
               <div>
                   <img src="./images/product2.PNG" alt="product"></img>
                   <h2>SPEEDBID</h2>
                   <Link to="/view2">View Demo</Link>
               </div> 
      </div>
      </TabPanel>
    </div>
  );
}
export default SimpleTabs; 